import type { Unit } from '../types/unit';
import type { WeaponData } from '../types/weapon';

/**
 * Get weapons array for a unit
 * Units in defcon-fulda don't have weapons array directly - they have weaponDescriptorName
 * that maps to weapons data
 */
export function getWeaponsForUnit(
  unit: Unit | undefined,
  weaponsData: { [descriptorName: string]: { descriptorName: string; hasDefensiveSmoke: boolean; weapons: WeaponData[] } } | null
): WeaponData[] {
  if (!unit || !unit.weaponDescriptorName || !weaponsData) {
    return [];
  }

  // Remove the $/GFX/Weapon/ prefix if present, as weapons are keyed without it
  const key = unit.weaponDescriptorName.replace(/^\$\/GFX\/Weapon\//, '');
  const weaponEntry = weaponsData[key];
  
  if (!weaponEntry || !weaponEntry.weapons) {
    return [];
  }

  return weaponEntry.weapons;
}

